angular.module('rjmNg.services').factory 'reportBuilder', [
  "$q"
  "dateService"
  "app"
  "$routeParams"
  "rjqlStringConstants"
  "restrictionSetService"
  "reportQueryType"
  "appRoute"
  "timeRangeEnums"
  "GoogleAnalytics"
  "Metrics"
  (
    $q
    dateService
    app
    $routeParams
    rjqlStringConstants
    restrictionSetService
    reportQueryType
    appRoute
    timeRangeEnums
    GoogleAnalytics
    Metrics
  ) ->

    # Is this a GA metric?
    isGaMetric = (metric) ->
      return metric.id instanceof Array

    isGaDimension = (column_id) ->
      is_string = isNaN(parseInt(column_id))
      return (("#{column_id}".match(/^ga:.*$/)?) || (is_string && !Object.values(rjqlStringConstants).includes(column_id)))

    # Extract all the values from the group by filters
    getValuesFromGroupByValueFilters = (metricFilters, dimensions) ->
      groupByValues = []

      # Keeps track of each dimension and add values to it
      # This assumes we haven't added the same dimension twice
      fieldMap = {}
      fieldMap[dim] = [] for dim in dimensions

      # Cycle through filters and add all groupbyvalues for each column_id
      for filters in metricFilters
        groupValues = {}
        for filter in filters
          fieldMap[filter.field] ?= []
          if filter.value instanceof Array
            fieldMap[filter.field] = fieldMap[filter.field].concat filter.value
          else
            fieldMap[filter.field] = fieldMap[filter.field].concat [filter.value]

      # Group by values are stored in the report builder as objects set to true
      for dim in dimensions
        valueMap = {}
        for column_id in fieldMap[dim]
          valueMap[column_id] = true
        groupByValues.push valueMap

      return groupByValues

    # Checks to see if we can safely add all these dimensions to a new metric
    hasCurrentDimensionsAvailable = (metric, currentDimensions) ->
      # Ensure the current dimension(s) is in the array of available
      # SIDs, and compare all SIDs as strings
      availableSids = metric.dimensionList.map (dim) -> return dim.column_id
      for currentDim in currentDimensions
        if availableSids.indexOf(currentDim.column_id) is -1
          return false

      return true

    # General async function to load the available dimensions from a regular
    # metric or a GA metric. Returns a promise to return the updated newMetric object
    loadAvailableDimensions = (newMetric, columns) ->
      dimensionPromise = $q.defer()
      # First get the dimension list for this metric
      if isGaMetric(newMetric)
        # We need to get the numerical id here
        dimensionPromise = GoogleAnalytics.getMetricDimensions(
          app.getClientId(),
          newMetric.numericalId
        ).then (dimensions) ->
          filterCondition = if newMetric.isGA4Live then 2 else 1;
          filteredDimensions = dimensions.filter((dim) -> dim.type is filterCondition)
          dimensions ?= []
          dimension.datatype = "VARCHAR(255)" for dimension in filteredDimensions
          newMetric.dimensionList = filteredDimensions
          return newMetric
      else
        dimensionPromise = Metrics.get(
          app.getClientId(),
          newMetric.id
        ).then (metric) ->
          newMetric.dimensionList = metric.dimensions.filter((dim) -> dim.column_id?)
          for dimension in newMetric.dimensionList
            dimension.name = columns[dimension.column_id].name
            dimension.datatype = columns[dimension.column_id].old_data_type
          return newMetric
      return dimensionPromise

    # We add the resolved dimensions to the metric and add some meta data to them
    addResolvedDimensionsToMetric = (metric, dimensions, columns, gaStructure) ->
      if dimensions
        metric.dimensions = dimensions

        # Set the name of the dimensions
        if metric.dimensions.length > 0
          for dimension in metric.dimensions
            if isGaDimension(dimension.column_id)
              dimension.name ?= _.find(gaStructure, (item) ->
                return item.column_id is dimension.column_id)?.name
              # Fallback just in case we can't find it
              dimension.name ?= dimension.column_id
            else if dimension.column_id isnt rjqlStringConstants.RJQL_UNBOUND
              dimension.name ?= columns[dimension.column_id].name
              dimension.datatype ?= columns[dimension.column_id].old_data_type
            else if dimension.column_id is rjqlStringConstants.RJQL_UNBOUND
              dimension.name ?= rjqlStringConstants.RJQL_UNBOUND_NAME
            else
              dimension.name ?= dimension.column_id

      return metric

    getReportBuilderPresentation = (figure) ->
      if figure.presentation.reportBuilder?
        presentation = angular.copy(figure.presentation.reportBuilder)
      else
        presentation = {}

      unless presentation.chart?.visible?
        presentation.chart ?= {}
        presentation.chart =
          visible: figure.presentationType?.id isnt 2

      unless presentation.table?.visible?
        presentation.table ?= {}
        presentation.table =
          visible: figure.presentationType?.id isnt 1

      return presentation

    metricIsValid = (metric) ->
      if metric?.type is 'formula'
        return metric.valid
      else if metric?.type is 'metric'
        return restrictionSetService.restrictionSetIsValid(metric.filters)
      else
        return false

    dimensionSortingIsValid = (metrics) ->
      if not metrics? then return [true]

      for metric in metrics when metric.type is 'metric'
        if metric.order? and metric.dimensions?
          mismatch = true
          if angular.equals(metric.order.fields, [[':value',':desc']]) or
            angular.equals(metric.order.fields, [[':value', ':asc']])
              mismatch = false
          else
            for field in metric.order.fields
              for dimension in metric.dimensions
                if ''+field[0] is ''+dimension.column_id then mismatch = false
        if mismatch
          return [false, metric]

      return [true]

    getReportBuilderPath = (figureId, type) ->
      if type is reportQueryType.RJQL
        return appRoute("/reports/#{figureId}")
      else if type is reportQueryType.SQL
        return appRoute("/reports/sql/#{figureId}")

    isPerspectiveAllowed = (metric, perspective, cohortView=false, version=0.1) ->
      # Checks for supported perspectives, for all unsupported returns false
      switch version
        when 1.0
          switch cohortView
            when true
              if perspective in [
                'standard'
                'cumulativeCohort'
                'percentOfFirstValueShowFirstValueCohort'
                'percentOfFirstValueHideFirstValueCohort'
              ]
                return true
              else if perspective in [
                'cumulativeAverageValuePerCohortMember'
                'averageValuePerCohortMember'
              ]
                return _doesCohortMetricSupportPerspective(metric)
            when false
              if perspective in [
                'standard'
                'cumulative'
                'amountVsPreviousPeriod'
                'amountVsPreviousYear'
                'percentVsPreviousPeriod'
                'percentVsPreviousYear'
                'percentOfFirstValueShowFirstValue'
                'rollingAverage'
              ]
                return _doesMetricSupportPerspective(metric, perspective)
        when 0.1
          if perspective in [
            'standard'
            'cumulative'
            'amountVsPreviousPeriod'
            'amountVsPreviousYear'
            'percentVsPreviousPeriod'
            'percentVsPreviousYear'
            'percentOfFirstValueShowFirstValue'
            'percentOfFirstValueHideFirstValue'
          ]
            return _doesMetricSupportPerspective(metric, perspective)

      return false

    # These perspectives cannot have more than one dimension
    isOneDimensionOnlyPerspective = (perspective) ->
      return perspective in [
        'amountVsPreviousPeriod',
        'amountVsPreviousYear',
        'percentVsPreviousPeriod',
        'percentVsPreviousYear'
      ]

    _doesMetricSupportPerspective = (metric, perspective) ->
      return if metric.dimensions.length > 1 and
        isOneDimensionOnlyPerspective(perspective) then false else true

    _doesCohortMetricSupportPerspective = (metric) ->
      return metric.dimensions[0]?.datatype is "DATETIME"

    generateDefaultTime = (interval, version=0.1, cohort=false, columnId=null) ->
      time =
        interval: interval
        intervalEnabled: true
      if cohort
        time.range =
          field: rjqlStringConstants.RJQL_PERIODDIFF
          start: 1
          end: 12
        time.timerange = [
            field: rjqlStringConstants.RJQL_TIME
            start:
              type: timeRangeEnums.RANGE_TYPES.MOVING
              value: -13
              unit: interval
            end:
              type: timeRangeEnums.RANGE_TYPES.MOVING
              value: 0
              unit: interval
          ,
            field: columnId
            start:
              type: timeRangeEnums.RANGE_TYPES.MOVING
              value: -13
              unit: interval
            end:
              type: timeRangeEnums.RANGE_TYPES.MOVING
              value: -1
              unit: interval
        ]
      else
        time.range = null
        time.timerange =
          start: 
            type: timeRangeEnums.RANGE_TYPES.MOVING
            unit: timeRangeEnums.TIME_INTERVAL_VALUES.YEAR
            value: -1
          end: 
            type: timeRangeEnums.RANGE_TYPES.MOVING
            unit: timeRangeEnums.TIME_INTERVAL_VALUES.YEAR
            value: 0
          field: dateService.timeVersion(version)

      return time

    _findCountingMember = (columnId, columns, remote = true) ->
      column = columns[columnId]
      if column.properties.derivative_type?
        if column.properties.derivative_type is "relocated_field"
          localId = column.properties.joins[0].local_column_ids[0]
          if remote
            return _findCountingMember(localId, columns)
          return
            columnId: localId
            tableId: column.table_id
        else if column.properties.derivative_type is "aggregate"
          localId = column.properties.joins[0].local_column_ids[0]
          foreignId = column.properties.joins[0].foreign_column_ids[0]
          if remote
            return
              columnId: foreignId
              tableId: columns[foreignId].table_id
          return
            columnId: localId
            tableId: column.table_id

      if column.reference_column_id is 0
        return
          columnId: column.id
          tableId: column.table_id
      else
        return
          columnId: column.reference_column_id
          tableId: columns[column.reference_column_id].table_id

    getCountingMembers = (metric, columns, remote = true) ->
      cohortTimeColumnId = metric.dimensions[0].column_id
      cohortTimeColumn = columns[cohortTimeColumnId]
      if cohortTimeColumn.properties.derivative_type? and
        cohortTimeColumn.properties.derivative_type in ["relocated_field", "aggregate"]
          countingMember = _findCountingMember(cohortTimeColumnId, columns, remote)

          countingMembers = {}
          countingMembers.field = countingMember.columnId
          countingMembers.table = countingMember.tableId
          countingMembers.alias = cohortTimeColumn.id

          if countingMember.tableId isnt cohortTimeColumn.table_id
            switch cohortTimeColumn.properties.derivative_type
              when "relocated_field"
                countingMembers.alias = cohortTimeColumn.properties.source_column_id
              when "aggregate"
                countingMembers.alias = cohortTimeColumn.properties.operand_column_id

      else
        countingMembers = null

      return countingMembers

    {
      isGaMetric
      isGaDimension
      getValuesFromGroupByValueFilters
      hasCurrentDimensionsAvailable
      loadAvailableDimensions
      addResolvedDimensionsToMetric
      getReportBuilderPresentation
      metricIsValid
      dimensionSortingIsValid
      getReportBuilderPath
      isPerspectiveAllowed
      isOneDimensionOnlyPerspective
      generateDefaultTime
      getCountingMembers
    }
  ]
